/**
 * 상품 등록일 검색 범위 — 화면의 날짜(yyyy-MM-dd) → BE `createdFrom` / `createdTo`.
 *
 * BE 는 두 값을 ISO 날짜-시각(`Instant`, `@DateTimeFormat(iso = DATE_TIME)`)으로 받는다. 날짜만 보내면
 * 변환에 실패해 400 이 나고 목록이 "상품 목록을 불러오지 못했습니다" 로 막혔다(목록·엑셀 다운로드 공통).
 * 경계는 둘 다 포함(created_at >= from, <= to)이라, 하루 전체가 들어가도록 한국 시간(KST, +09:00) 기준으로
 * 시작일 00:00:00.000 · 종료일 23:59:59.999 를 UTC ISO 문자열로 만든다.
 */
const KST_OFFSET = '+09:00';
const YMD = /^\d{4}-\d{2}-\d{2}$/;

const toIso = (local: string): string | undefined => {
  const d = new Date(local);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
};

/** 시작일(포함) — 그날 00:00:00.000 KST. 날짜가 아니면 undefined(전송 안 함). */
export const createdFromParam = (ymd: string | null | undefined): string | undefined =>
  ymd && YMD.test(ymd) ? toIso(`${ymd}T00:00:00.000${KST_OFFSET}`) : undefined;

/** 종료일(포함) — 그날 23:59:59.999 KST. 날짜가 아니면 undefined(전송 안 함). */
export const createdToParam = (ymd: string | null | undefined): string | undefined =>
  ymd && YMD.test(ymd) ? toIso(`${ymd}T23:59:59.999${KST_OFFSET}`) : undefined;
